import { render, staticRenderFns } from "./donutChart.vue?vue&type=template&id=8f199ff4&"
import script from "./donutChart.vue?vue&type=script&lang=js&"
export * from "./donutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports